import "core-js/modules/es6.regexp.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getImUserSelector, getUserInfoList } from '@/api/permission/user';
export default {
  name: 'userSelect',
  props: {
    value: {
      default: ''
    },
    interfaceId: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      visible: false,
      keyword: '',
      nodeId: '',
      innerValue: '',
      loading: false,
      props: {
        children: 'children',
        label: 'fullName',
        isLeaf: 'isLeaf'
      },
      treeData: [],
      selectedData: []
    };
  },
  watch: {
    value: function value(val) {
      this.setDefault();
    }
  },
  created: function created() {
    this.setDefault();
  },
  methods: {
    clear: function clear() {
      if (this.disabled) return;
      this.innerValue = '';
      this.selectedData = [];
      this.$emit('input', '');
      this.$emit('change', '', '');
    },
    openDialog: function openDialog() {
      if (this.disabled) return;
      this.visible = true;
      this.keyword = '';
      this.nodeId = '0';
      this.getList();
    },
    confirm: function confirm() {
      var txt = '',
        ids = '';
      for (var i = 0; i < this.selectedData.length; i++) {
        txt += (i ? ',' : '') + this.selectedData[i].fullName;
        ids += (i ? ',' : '') + this.selectedData[i].id;
      }
      this.innerValue = txt;
      this.$emit('input', ids);
      this.$emit('change', ids, this.selectedData);
      this.visible = false;
    },
    setDefault: function setDefault() {
      var _this = this;
      this.selectedData = [];
      if (!this.value) return this.innerValue = '';
      var arr = this.value.split(',');
      getUserInfoList(arr).then(function (res) {
        var list = res.data.list;
        _this.selectedData = list;
        var txt = '';
        for (var i = 0; i < list.length; i++) {
          txt += (i ? ',' : '') + list[i].fullName;
        }
        _this.innerValue = txt;
      });
    },
    getList: function getList() {
      var _this2 = this;
      this.loading = true;
      if (this.keyword) this.nodeId = '0';
      getImUserSelector(this.nodeId, this.keyword).then(function (res) {
        _this2.treeData = res.data.list;
        _this2.loading = false;
      });
    },
    loadNode: function loadNode(node, resolve) {
      if (node.level === 0) {
        this.nodeId = '0';
        return resolve(this.treeData);
      }
      this.nodeId = node.data.id;
      getImUserSelector(this.nodeId).then(function (res) {
        resolve(res.data.list);
      });
    },
    handleNodeClick: function handleNodeClick(data) {
      if (data.type !== 'user') return;
      var boo = this.selectedData.some(function (o) {
        return o.id === data.id;
      });
      if (boo) return;
      var item = {
        id: data.id,
        fullName: data.fullName
      };
      this.multiple ? this.selectedData.push(item) : this.selectedData = [item];
    },
    removeAll: function removeAll() {
      this.selectedData = [];
    },
    removeData: function removeData(index) {
      this.selectedData.splice(index, 1);
    }
  }
};